var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterPageStoreWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1253_173120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2H11.15C10.82 0.85 9.76 0 8.5 0C7.24 0 6.18 0.85 5.85 2H4.75C4.34 2 4 2.34 4 2.75V4.25C4 5.21 4.79 6 5.75 6H11.25C12.21 6 13 5.21 13 4.25V2.75C13 2.34 12.66 2 12.25 2Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 3H14V4.25C14 5.77 12.77 7 11.25 7H5.75C4.23 7 3 5.77 3 4.25V3H2.75C1.23 3 0 4.23 0 5.75V18.25C0 19.77 1.23 21 2.75 21H9.34C8.84 19.93 8.54 18.75 8.51 17.5H3.75C3.34 17.5 3 17.16 3 16.75C3 16.34 3.34 16 3.75 16H8.59C8.68 15.39 8.83 14.81 9.03 14.25H3.75C3.34 14.25 3 13.91 3 13.5C3 13.09 3.34 12.75 3.75 12.75H9.75C10.14 12.11 10.6 11.52 11.14 11H3.75C3.34 11 3 10.66 3 10.25C3 9.84 3.34 9.5 3.75 9.5H13.19C14.34 8.9 15.63 8.54 17 8.51V5.75C17 4.23 15.77 3 14.25 3Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 10.5C13.528 10.5 10.5 13.528 10.5 17.25C10.5 20.972 13.528 24 17.25 24C20.972 24 24 20.972 24 17.25C24 13.528 20.972 10.5 17.25 10.5ZM20.502 15.909L17.002 19.909C16.82 20.117 16.56 20.241 16.283 20.25C16.272 20.25 16.261 20.25 16.25 20.25C15.985 20.25 15.731 20.145 15.543 19.957L13.543 17.957C13.152 17.566 13.152 16.934 13.543 16.543C13.934 16.152 14.566 16.152 14.957 16.543L16.201 17.787L18.997 14.591C19.361 14.177 19.992 14.133 20.408 14.497C20.824 14.861 20.866 15.493 20.502 15.909Z",
    fill: "#50429B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1253_173120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterPageStoreWeb);
export default __webpack_public_path__ + "static/media/register-page-store-web.94b326b8bb1b20999d80e7d75de9fed5.svg";
export { ForwardRef as ReactComponent };